/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_Lesson_OptionsInputs */

const en_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Lesson Options`)
};

const es_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver opciones de lección`)
};

const de_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunden ansehen`)
};

const zh_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看课程选项`)
};

const ar_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطّلع على خيارات الدروس`)
};

const fr_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les options de cours`)
};

const vi_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem các lựa chọn bài học`)
};

const sw_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazama Chaguzi za Somo`)
};

const th_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูตัวเลือกบทเรียน`)
};

const bs_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pogledaj opcije lekcija`)
};

const ja_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンオプションを見る`)
};

const ko_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수업 옵션 보기`)
};

const pt_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver opções de aula`)
};

const it_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi le opzioni di lezione`)
};

const sv_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se lektionsalternativ`)
};

const nl_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie lesopties`)
};

const da_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Lektionsindstillinger`)
};

const nb_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se Leksjonsalternativer`)
};

const fi_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso oppituntiasetukset`)
};

const pl_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz opcje lekcji`)
};

const ru_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотрите варианты уроков`)
};

const tr_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders seçeneklerine bakın`)
};

const hi_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ विकल्प देखें`)
};

const id_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Opsi Pelajaran`)
};

const ms_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Pilihan Pelajaran`)
};

const cs_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viz Možnosti lekce`)
};

const el_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλογές μαθήματος`)
};

const he_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אפשרויות לשיעור`)
};

const af_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sien lesopsies`)
};

const hu_home_cta_lesson_options = /** @type {(inputs: Home_Cta_Lesson_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óratípusok megtekintése`)
};

/**
* | output |
* | --- |
* | "See Lesson Options" |
*
* @param {Home_Cta_Lesson_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_cta_lesson_options = /** @type {((inputs?: Home_Cta_Lesson_OptionsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_Lesson_OptionsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_lesson_options(inputs)
	if (locale === "de") return de_home_cta_lesson_options(inputs)
	if (locale === "zh") return zh_home_cta_lesson_options(inputs)
	if (locale === "ar") return ar_home_cta_lesson_options(inputs)
	if (locale === "fr") return fr_home_cta_lesson_options(inputs)
	if (locale === "vi") return vi_home_cta_lesson_options(inputs)
	if (locale === "sw") return sw_home_cta_lesson_options(inputs)
	if (locale === "th") return th_home_cta_lesson_options(inputs)
	if (locale === "bs") return bs_home_cta_lesson_options(inputs)
	if (locale === "ja") return ja_home_cta_lesson_options(inputs)
	if (locale === "ko") return ko_home_cta_lesson_options(inputs)
	if (locale === "pt") return pt_home_cta_lesson_options(inputs)
	if (locale === "it") return it_home_cta_lesson_options(inputs)
	if (locale === "sv") return sv_home_cta_lesson_options(inputs)
	if (locale === "nl") return nl_home_cta_lesson_options(inputs)
	if (locale === "da") return da_home_cta_lesson_options(inputs)
	if (locale === "nb") return nb_home_cta_lesson_options(inputs)
	if (locale === "fi") return fi_home_cta_lesson_options(inputs)
	if (locale === "pl") return pl_home_cta_lesson_options(inputs)
	if (locale === "ru") return ru_home_cta_lesson_options(inputs)
	if (locale === "tr") return tr_home_cta_lesson_options(inputs)
	if (locale === "hi") return hi_home_cta_lesson_options(inputs)
	if (locale === "id") return id_home_cta_lesson_options(inputs)
	if (locale === "ms") return ms_home_cta_lesson_options(inputs)
	if (locale === "cs") return cs_home_cta_lesson_options(inputs)
	if (locale === "el") return el_home_cta_lesson_options(inputs)
	if (locale === "he") return he_home_cta_lesson_options(inputs)
	if (locale === "af") return af_home_cta_lesson_options(inputs)
	if (locale === "hu") return hu_home_cta_lesson_options(inputs)
	return en_home_cta_lesson_options(inputs)
});